"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCurrencyRupee = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M6 2a1 1 0 0 0 0 2h3c1.395 0 2.368.513 3.003 1.227.437.492.738 1.107.887 1.773H6a1 1 0 0 0 0 2h6.89c-.15.666-.45 1.28-.887 1.773C11.368 11.487 10.395 12 9 12H6a.996.996 0 0 0-1 1 .996.996 0 0 0 .308.722l.009.008 8.498 7.998a1 1 0 0 0 1.37-1.456L8.522 14H9c1.938 0 3.465-.737 4.498-1.898.784-.883 1.253-1.976 1.426-3.102H18a1 1 0 1 0 0-2h-3.076c-.166-1.083-.606-2.136-1.338-3H18a1 1 0 1 0 0-2H6Z", fill: "currentColor" }) }))); };
exports.default = SvgCurrencyRupee;
